import { useUrlQuery } from './use-url-query'

export const useWorkspaceId = () => {
  return useUrlQuery('workspace')
}
